import React from "react";
import { hexToRgb } from "../utils/helpers";

const Cta = ({ className, bgColor, bgImage }) => {
  let rgb = { r: 0, g: 83, b: 159 };
  if (bgColor && hexToRgb(bgColor) !== null) rgb = hexToRgb(bgColor);
  let hoverCss = `0px 0px 0px 4px rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.4)`;
  return (
    <span
      className={className}
      style={{
        backgroundColor: bgColor,
        backgroundImage: bgImage
      }}
      onMouseOver={e => (e.target.style.boxShadow = hoverCss)}
      onMouseOut={e => (e.target.style.boxShadow = "none")}
    />
  );
};

export default Cta;
